enum ContractType {
  Standard = 0,
  Service = 1
}

export default ContractType;
